/**
 * This file provides an interface for initializing small snippet-components.
 */

import OnlineBanking from './components/onlineBanking';
import React from 'react';
import ReactDOM from 'react-dom';

function snippetsInit() {
  // init online banking snippet in the navigation
  ReactDOM.render(<OnlineBanking />, document.getElementById('online-banking'));
  // ... list further content snippets here ...
}

export { snippetsInit };



// WEBPACK FOOTER //
// ./snippetsInit.js